import React from "react";
import style from "../../styles/addtocart.module.scss";
import { useCart } from "react-use-cart";
import { trackAddToCart } from "../../utils/tracking";
import { IoCartOutline } from "react-icons/io5";
import { useCartDrawer } from "../../context/CartDrawerContext";

const AddToCart = ({ product, quantity }) => {
  const { addItem } = useCart();
  const { openDrawer } = useCartDrawer();

  if (product?.notInStock) return null;

  return (
    <button
      className={style.button}
      onClick={() => {
        if (product?.notInStock) return;
        addItem(product, quantity);
        trackAddToCart(product, quantity);
        openDrawer();
      }}
    >
      <IoCartOutline size={30} />
      Shto në shportë
    </button>
  );
};

export default AddToCart;
